<!-- Button to open the chat window -->
<div class="openChatIcon" (click)="toggleChatWindow()"></div>

<!-- Chat window overlay -->
@if (isOpen) {
<div class="chatOverlay">
  <div class="chatbotContainer" id="chatWindow">
    <div class="chatbotHeader" id="chatWindowHeader">
      <div class="chatbot-title">E.L.L.A</div>
      <button id="close-button" (click)="closeChatbot()">
        <mat-icon class="close-icon">close</mat-icon>
      </button>
    </div>
    <div class="chatHistoryContainer" id="scrollContainer">
      <div class="chatbotMessage">
        <img
          src="/assets/icons/Icon - Chatbot.png"
          alt="Chat Icon"
          class="chatIcon"
        />
        <p class="disclaimerText">
          Disclaimer: Please remember that answers provided by this assistance
          are not to be taken literal. These are simply recommendations based on
          past lessons learned and proper due diligence should be completed for
          each unique scenario.
        </p>
      </div>
      <div class="chatbotMessage">
        <img
          src="/assets/icons/Icon - Chatbot.png"
          alt="Chat Icon"
          class="chatIcon"
        />
        <p class="chatbotText">
          Hello {{ currentFullUserProfile.name }}! My name's E.L.L.A or
          Enterprise Lessons Learned Assist! I specialize in all things Lessons
          Learned.How can I help you today?
        </p>
      </div>
      <div class="chatHistory">
        @for (comm of chatHistory; track comm; let chatId = $index) {
        <div>
          <div class="userMessage" id="user{{ chatId }}">
            <p class="userText">{{ comm.inputs }}</p>
            @if (photoData) {
            <img [src]="photoData" alt="image" class="userIcon" />
            }
          </div>
          <div class="chatbotMessage">
            <img
              src="/assets/icons/Icon - Chatbot.png"
              alt="Chat Icon"
              class="chatIcon"
            />
            @if (comm.outputs) {
            <div
              class="chatbotText"
              id="chatbot{{ chatId }}"
              [innerHtml]="comm.outputs"
            ></div>
            }
          </div>
        </div>
        } @if (isLoading) {
        <div>
          <div class="userMessage" id="tempUserChat">
            <p class="userText">{{ tempUserChat }}</p>
            @if (photoData) {
            <img [src]="photoData" alt="image" class="userIcon" />
            }
          </div>
          <div class="chatbotMessage" id="tempChatbotSpinner">
            <div class="chatbotTextLoading">
              <img
                src="/assets/icons/Icon - Chatbot.png"
                alt=""
                class="chatIcon"
              />
              <span class="waitingMessage" role="status" aria-live="polite" aria-atomic="true">{{ waitingMessage }}</span>
              <span class="loadingDots" aria-hidden="true">
                <span class="dot">.</span>
                <span class="dot">.</span>
                <span class="dot">.</span>
              </span>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    <div class="samplePromptsContainer">
      @if (chatHistory.length === 0) {
      <div>
        <div class="sampleQuestions">
          @for (question of samplePrompts; track question) {
          <button (click)="sendMessage(question)">
            {{ question }}
          </button>
          }
        </div>
      </div>
      }
    </div>
  </div>
  <form id="input-form" (ngSubmit)="sendMessage(query)">
    <div class="queryContainer">
      <input
        id="input-field"
        type="text"
        placeholder="Got a question? Ask away!"
        [(ngModel)]="query"
        name="query"
      />
      <button id="submit-button" type="submit" aria-label="Send message">
        <mat-icon class="submit-icon">send</mat-icon>
      </button>
      <button id="new-chat-button" type="reset" (click)="clearChat()">
        <mat-icon>add_comment</mat-icon>
      </button>
    </div>
  </form>
</div>
}
